var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6239 0.195262C11.8843 0.455611 11.8843 0.877721 11.6239 1.13807L6.8524 5.90963L11.8047 10.8619C12.0651 11.1223 12.0651 11.5444 11.8047 11.8047C11.5444 12.0651 11.1223 12.0651 10.8619 11.8047L5.90959 6.85243L1.13807 11.6239C0.877721 11.8843 0.455611 11.8843 0.195262 11.6239C-0.0650875 11.3636 -0.0650873 10.9415 0.195262 10.6811L4.96678 5.90963L0.376053 1.31886C0.115705 1.05851 0.115706 0.636403 0.376057 0.376054C0.636407 0.115706 1.05852 0.115708 1.31887 0.376058L5.90959 4.96682L10.6811 0.195262C10.9415 -0.0650873 11.3636 -0.0650875 11.6239 0.195262Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4e00b049553a75a21b86b64f14baaeb8.svg";
export { ForwardRef as ReactComponent };